import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import styled, { createGlobalStyle } from 'styled-components';
import CreditCardVisual from 'components/PayCardPreview';

const GlobalPaymentStyles = createGlobalStyle`
  .kr-embedded form {
    font-family: 'Segoe UI', sans-serif;
    color: #103F58;
    background-color: #fff;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(16, 63, 88, 0.1);
  }

  .kr-embedded button {
    background-color: #00aaa8 !important;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    font-weight: 600;
    transition: background 0.2s;
  }

  .kr-embedded button:hover {
    background-color: #0a2c3e;
  }

  .kr-card-form.kr-embedded{
      justify-self: center !important;
  }
`;

const EcContainer = styled.div`
  max-width: 520px;
  margin: 0 auto;
`;

/*const EcHeader = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
`;*/

const EcTitle = styled.h2`
  color: #303030;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
`;

/*const EcAmount = styled.div`
  font-size: 2rem;
  color: #4a6cf7;
  margin: 0.5rem 0;
  font-weight: 700;
`;*/

/*const EcSubtitle = styled.div`
  color: #666;
  font-size: 0.9rem;
`;*/

const EcFormContainer = styled.div`
  min-height: 300px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  padding: 1rem;
  background-color: #fff;
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
`;

const EcErrorMessage = styled.div`
  color: #d9534f;
  padding: 0.75rem;
  margin: 1rem 0;
  border-radius: 6px;
  background-color: rgba(217, 83, 79, 0.1);
  border-left: 4px solid #d9534f;
  font-size: 0.9rem;
`;

const EcSecureInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  color: #6c757d;
  font-size: 0.8rem;

  svg {
    margin-right: 0.5rem;
    color: #28a745;
  }
`;

const SogecommercePayment = ({
    formToken,
    amount,
    title,
    subtitle,
    currency = 'EUR',
    publicKey,
    onSuccess,
    onError
}) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cardBrand, setCardBrand] = useState('default'); // Ex: 'visa', 'mastercard', 'amex'
    const [focusedField, setFocusedField] = useState('');

    /*const formatAmount = (amount, currency) => {
        if (!amount) return '';
        const formatter = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2
        });
        return formatter.format(amount / 100);
    };*/

    const cleanupSogecommerceResources = () => {
        // 1. Supprimer les scripts
        document.querySelectorAll('script[src*="sogecommerce"]').forEach(script => {
            script.parentNode?.removeChild(script);
        });

        // 2. Supprimer les styles
        document.querySelectorAll('link[href*="sogecommerce"]').forEach(style => {
            style.parentNode?.removeChild(style);
        });

        // 3. Vider le conteneur du formulaire
        const formContainer = document.querySelector('.kr-embedded');
        if (formContainer) {
            formContainer.innerHTML = '';
        }

        // 4. Nettoyer les variables globales
        window.KR = undefined;
        window.KR_CONFIGURATION = undefined;
        window.sogecommerceScriptLoaded = undefined;
    };

    useEffect(() => {
        if (formToken && publicKey) {
            const initSogecommerce = () => {
                const mainScript = document.createElement('script');
                mainScript.type = 'text/javascript';
                mainScript.src = 'https://static-sogecommerce.societegenerale.eu/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js';
                mainScript.setAttribute('kr-public-key', publicKey);
                mainScript.setAttribute('kr-language', 'fr-FR');
                mainScript.setAttribute('kr-form-token', formToken);
                mainScript.setAttribute('onload', 'sogecommerceScriptLoaded()');

                window.sogecommerceScriptLoaded = () => {
                    if (window.KR) {
                        // Détection de la marque de carte
                        window.KR.onBrandChanged(event => {
                            console.log("Brand changed:", event);
                            if (event && event.cardInfo) {
                                // Convertir en minuscule pour correspondre aux propriétés attendues par CreditCardVisual
                                const brandLower = event.cardInfo.brand.toLowerCase();

                                setCardBrand(
                                    // Map des valeurs possibles retournées par SOGECOMMERCE vers les valeurs acceptées par votre composant
                                    {
                                        'visa': 'visa',
                                        'mastercard': 'mastercard',
                                        'amex': 'amex',
                                        'american express': 'amex',
                                    }[brandLower] || 'default'
                                );
                            } else {
                                setCardBrand('default');
                            }
                        });

                        // Gestion du focus pour retourner la carte au moment approprié
                        window.KR.onFocus(event => {
                            console.log("Focus event:", event);
                            if (event) {
                                const field = event.field?.toLowerCase() || '';

                                setTimeout(() => {
                                    // Déterminer quel champ est en focus pour l'animation de la carte
                                    if (field.includes('pan') && !field.includes('holder')) {
                                        setFocusedField('number');
                                    } else if (field.includes('holder')) {
                                        setFocusedField('name');
                                    } else if (field.includes('expiry')) {
                                        setFocusedField('expiry');
                                    } else if (field.includes('security') || field.includes('cvc')) {
                                        setFocusedField('cvc');
                                    } else {
                                        setFocusedField('some');
                                    }
                                }, 100);
                            }
                        });

                        // Réinitialiser le focus lorsqu'on quitte un champ
                        window.KR.onBlur(event => {
                            console.debug(event);
                            if (event) {
                                const field = event.field?.toLowerCase() || '';
                                /*if (field.includes('security') || field.includes('cvc') && focusedField.length==0) {
                                    setFocusedField('name');
                                }*/
                                if (field.length > 0 && focusedField.length === 0) {
                                    setFocusedField('name');
                                }
                            }
                            //setFocusedField('');
                        });

                        // Formulaire chargé
                        window.KR.onFormReady(() => {
                            console.log("Formulaire SOGECOMMERCE chargé avec succès");
                            setLoading(false);
                        });


                        // Gestion de la soumission du formulaire avec récupération des résultats
                        window.KR.onSubmit(response => {
                            console.log("Résultat du paiement:", response);
                            // Récupération des détails du paiement
                            const transactionDetails = {
                                orderId: response?.clientAnswer?.orderId,
                                transactionId: response?.clientAnswer?.transactionUuid,
                                amount: response?.clientAnswer?.amount,
                                currency: response?.clientAnswer?.currency,
                                orderStatus: response?.clientAnswer?.orderStatus,
                                paymentMethod: response?.clientAnswer?.paymentMethodType,
                                date: response?.clientAnswer?.serverDate,
                                customerDetails: {
                                    email: response?.clientAnswer?.customer?.email,
                                    reference: response?.clientAnswer?.customer?.reference
                                }
                            };

                            // Journaliser les détails pour débogage
                            console.log("Détails de la transaction:", transactionDetails);

                            // Vérifier si le paiement a réussi
                            if (response?.clientAnswer?.orderStatus === 'PAID') {
                                // Stocker les résultats si nécessaire
                                sessionStorage.setItem('lastPaymentResult', JSON.stringify(transactionDetails));

                                // Appeler le callback de succès avec les détails
                                onSuccess?.(transactionDetails);
                            } else {
                                // Journaliser l'erreur
                                console.warn("Échec du paiement:", response?.clientAnswer?.orderStatus);

                                // Définir le message d'erreur en fonction du statut
                                let errorMessage = 'Le paiement a été refusé.';
                                if (response?.clientAnswer?.orderStatus === 'CANCELLED') {
                                    errorMessage = 'Le paiement a été annulé.';
                                } else if (response?.clientAnswer?.orderStatus === 'REFUSED') {
                                    errorMessage = 'Le paiement a été refusé par la banque.';
                                }

                                setError(errorMessage);
                                onError?.(response);

                                // Rafraîchir la page après un délai (pour l'annulation)
                                if (response?.clientAnswer?.orderStatus === 'CANCELLED') {
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 2000); // Rafraîchir après 2 secondes
                                }
                            }
                        });


                    } else {
                        setError('Erreur de chargement du formulaire de paiement');
                        setLoading(false);
                    }
                };

                document.head.appendChild(mainScript);

                // CSS du thème
                const styleLink = document.createElement('link');
                styleLink.rel = 'stylesheet';
                styleLink.href = 'https://static-sogecommerce.societegenerale.eu/static/js/krypton-client/V4.0/ext/neon-reset.min.css';
                document.head.appendChild(styleLink);

                // Script du thème
                const themeScript = document.createElement('script');
                themeScript.type = 'text/javascript';
                themeScript.src = 'https://static-sogecommerce.societegenerale.eu/static/js/krypton-client/V4.0/ext/neon.js';
                document.head.appendChild(themeScript);


            };

            cleanupSogecommerceResources();
            initSogecommerce();
        } else {
            setError('Paramètres manquants (formToken ou publicKey)');
            setLoading(false);

        }

        return cleanupSogecommerceResources;
    }, [formToken, publicKey, onSuccess, onError]);

    return (
        <EcContainer>
            <GlobalPaymentStyles />
            <EcTitle>{title}</EcTitle>
            <CreditCardVisual
                number="4111111111111111"
                name="Jean Dupont"
                expiry="12/26"
                cvc="123"
                focused={focusedField}
                brand={cardBrand}
            />

            {error && <EcErrorMessage>{error}</EcErrorMessage>}

            <EcFormContainer>
                {loading ? (
                    <SpinnerContainer>
                        <Spinner color="primary" />
                        <div className="mt-3">Chargement du formulaire de paiement...</div>
                    </SpinnerContainer>
                ) : null}

                <div
                    className="kr-embedded"
                    style={{
                        display: loading ? 'none' : 'block'
                    }}
                ></div>
            </EcFormContainer>

            <EcSecureInfo>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9 12L11 14L15 10"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Paiement sécurisé par SOGECOMMERCE
            </EcSecureInfo>
        </EcContainer>
    );
};

export default SogecommercePayment;